/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Navigation.css';
import Link from '../Link';

// const messages = defineMessages({
//   about: {
//     id: 'navigation.about',
//     defaultMessage: 'About',
//     description: 'About link in header',
//   },
//   contact: {
//     id: 'navigation.contact',
//     defaultMessage: 'Contact',
//     description: 'Contact link in header',
//   },
//   login: {
//     id: 'navigation.login',
//     defaultMessage: 'Log in',
//     description: 'Log in link in header',
//   },
//   or: {
//     id: 'navigation.separator.or',
//     defaultMessage: 'or',
//     description: 'Last separator in list, lowercase "or"',
//   },
//   signup: {
//     id: 'navigation.signup',
//     defaultMessage: 'Sign up',
//     description: 'Sign up link in header',
//   },
// });

class Navigation extends React.Component {

  static propTypes = {
    className: PropTypes.string,
  };

  render() {
    const { className } = this.props;
    return (
      <div className={cx(s.root, className)} role="navigation">
        Navigation
        {/*<Link className={s.link} to="/about">
          <FormattedMessage {...messages.about} />
        </Link>
        <Link className={s.link} to="/contact">
          <FormattedMessage {...messages.contact} />
        </Link>
        <span className={s.spacer}> | </span>
        <Link className={s.link} to="/login">
          <FormattedMessage {...messages.login} />
        </Link>
        <span className={s.spacer}>
          <FormattedMessage {...messages.or} />
        </span>
        <Link className={cx(s.link, s.highlight)} to="/register">
          <FormattedMessage {...messages.signup} />
        </Link>*/}
      </div>
    );
  }
}

export default withStyles(s)(Navigation);



// WEBPACK FOOTER //
// src/components/Navigation/Navigation.js